module.exports = __webpack_public_path__ + "static/media/microverse-weather-context.5554e593.png";